export default {
      id: "info-base-usage",
      viewBox: "0 0 17 17",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#info-base",
      toString: function () {
        return this.url;
      }
    }